interface SessionStorageDictionary {
  PORTAL_CONFIG: SessionStorageKey;
  USER_CONFIG: SessionStorageKey;
  WARNING_BANNER_DISMISSED: SessionStorageKey;
}

export type SessionStorageKey = keyof SessionStorageDictionary;

export const sessionStorageDictionary: SessionStorageDictionary = {
  PORTAL_CONFIG: 'PORTAL_CONFIG',
  USER_CONFIG: 'USER_CONFIG',
  WARNING_BANNER_DISMISSED: 'WARNING_BANNER_DISMISSED',
};

export const setSessionStorage = (
  key: SessionStorageKey,
  value: object | string,
) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSessionStorage = (key: SessionStorageKey) => {
  const value = sessionStorage.getItem(key);

  return value ? JSON.parse(value) : null;
};

export const clearSessionStorage = (key: SessionStorageKey) => {
  sessionStorage.removeItem(key);
};
